export function reducer(draft, action) {
   switch (action.type) {
      case 'updatePupil':
         if (draft.pupil[action.key] !== action.value) {
            draft.pupil[action.key] = action.value
         }
         return
      case 'updateGuardian':
         if (draft.guardians[action.guardian][action.key] !== action.value) {
            draft.guardians[action.guardian][action.key] = action.value
         }
         return
      case 'createSibling':
         if (draft.siblings[action.sibling] === undefined) {
            draft.siblings[action.sibling] = {}
         }
         return
      case 'updateSibling':
         if (
            draft.siblings[action.sibling] &&
            draft.siblings[action.sibling][action.key] !== action.value
         ) {
            draft.siblings[action.sibling][action.key] = action.value
         }
         return
      case 'updateFritids':
         if (draft.fritids[action.key] !== action.value) {
            draft.fritids[action.key] = action.value
         }
         return
      default:
         console.log('Unknown action', action)
         return
   }
}
